import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
}), 'FastForwardSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FastForwardSharp.js
// module id = 3507
// module chunks = 2